import React from 'react';

import cn from '@/utils/cn';

import { calloutClass, toneText } from './tone';

interface Props {
  count: number;
  onReview: () => void;
}

// Reset the native button chrome (tw- prefix means preflight doesn't) to a plain accent text link.
const REVIEW = 'tw-ml-auto tw-cursor-pointer tw-appearance-none tw-whitespace-nowrap tw-border-0 '
  + 'tw-bg-transparent tw-p-0 tw-text-sm tw-font-bold tw-text-spa-accent-text hover:tw-underline';

// Print reading text the tool couldn't attach to a section — shown up front (not buried in the
// Detected tab) so a "nothing changed" read is trustworthy, with a jump to review them.
const UnmatchedCallout = ({ count, onReview }: Props) => (
  <div className={cn(calloutClass('error'), 'tw-mt-4 tw-flex tw-items-center tw-gap-3 tw-px-4')}>
    <span aria-hidden="true">⚠️</span>
    <span className={cn('tw-text-sm', toneText.error)}>
      <strong>{count} print {count === 1 ? 'section' : 'sections'} didn’t map to an online section.</strong>{' '}
      Reading text the tool couldn’t attach — review before trusting “unchanged.”
    </span>
    <button className={REVIEW} type="button" onClick={onReview}>
      Review →
    </button>
  </div>
);

export default UnmatchedCallout;
